// Contract addresses (update these after deployment)
export const CONTRACTS = {
  MARKET_ADDRESS: '0x4e8042c4ff25a2c97afb9d2759906be45791c221',
  USDC_ADDRESS: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
  // USDC_ADDRESS: '0x036CbD53842c5426634e7929541eC2318f3dCF7e',  //sepolia
  POSITION_TOKEN_ADDRESS: '0x4fdaf87271a209a7fb9f13f80ae58fcea5f99f35',  // 1155
};

// Network configuration
export const NETWORKS = {
  BASE: {
    chainId: 8453,
    name: 'Base',
    rpcUrl: 'https://mainnet.base.org',
    currency: 'ETH',
    explorerUrl: 'https://basescan.org'
  },
  BASE_SEPOLIA: {
    chainId: 84532,
    name: 'Base Sepolia',
    rpcUrl: 'https://sepolia.base.org',
    currency: 'ETH',
    explorerUrl: 'https://sepolia.basescan.org'
  },
};

// APY Prediction Market ABI
export const MARKET_ABI = [
  {
    inputs: [
      { name: "name", type: "string" },
      { name: "startBlock", type: "uint256" },
      { name: "endBlock", type: "uint256" },
      { name: "secondsPerBlock", type: "uint256" },
      { name: "referenceTxnHash", type: "string" },
      { name: "durationEnum", type: "uint8" },
      { name: "startApy", type: "uint256" },
      {
        name: "thresholds",
        type: "tuple",
        components: [
          { name: "threshold1", type: "int256" },
          { name: "threshold2", type: "int256" },
          { name: "threshold3", type: "int256" },
          { name: "threshold4", type: "int256" },
          { name: "threshold5", type: "int256" }
        ]
      }
    ],
    name: "createOpportunity",
    outputs: [{ name: "id", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "id", type: "uint256" },
      { name: "optionIndex", type: "uint8" },
      { name: "amount", type: "uint256" }
    ],
    name: "placeBet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "id", type: "uint256" },
      { name: "finalApy", type: "uint256" }
    ],
    name: "resolveOpportunity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ name: "id", type: "uint256" }],
    name: "voidOpportunity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "oppId", type: "uint256" },
      { name: "optionIndex", type: "uint8" }
    ],
    name: "getTokenId",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [{ name: "id", type: "uint256" }],
    name: "getOpportunity",
    outputs: [
      {
        components: [
          { name: "name", type: "string" },
          { name: "startBlock", type: "uint256" },
          { name: "endBlock", type: "uint256" },
          { name: "secondsPerBlock", type: "uint256" },
          { name: "referenceTxnHash", type: "string" },
          { name: "startApy", type: "uint256" },
          { name: "finalApy", type: "uint256" },
          { name: "resolved", type: "bool" },
          { name: "voided", type: "bool" },
          { name: "winningOption", type: "uint8" },
          { name: "rewardPerToken", type: "uint256" },
          { name: "durationEnum", type: "uint8" },
          { name: "thresholds", type: "int256[5]" }
        ],
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "id", type: "uint256" }],
    name: "getTotalStakePerOption",
    outputs: [{ name: "totals", type: "uint256[6]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "id", type: "uint256" }],
    name: "getUniqueBettorsPerOption",
    outputs: [{ name: "counts", type: "uint256[6]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "id", type: "uint256" }],
    name: "getBettingWindow",
    outputs: [
      { name: "bettingStart", type: "uint256" },
      { name: "bettingEnd", type: "uint256" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getOpportunityCount",
    outputs: [{ name: "count", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "startId", type: "uint256" },
      { name: "count", type: "uint256" }
    ],
    name: "getOpportunitiesRange",
    outputs: [
      {
        components: [
          { name: "name", type: "string" },
          { name: "startBlock", type: "uint256" },
          { name: "endBlock", type: "uint256" },
          { name: "secondsPerBlock", type: "uint256" },
          { name: "referenceTxnHash", type: "string" },
          { name: "startApy", type: "uint256" },
          { name: "finalApy", type: "uint256" },
          { name: "resolved", type: "bool" },
          { name: "voided", type: "bool" },
          { name: "winningOption", type: "uint8" },
          { name: "rewardPerToken", type: "uint256" },
          { name: "durationEnum", type: "uint8" },
          { name: "thresholds", type: "int256[5]" }
        ],
        name: "opps",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "startId", type: "uint256" },
      { name: "count", type: "uint256" }
    ],
    name: "getOpportunitiesWithPools",
    outputs: [
      {
        components: [
          { name: "name", type: "string" },
          { name: "startBlock", type: "uint256" },
          { name: "endBlock", type: "uint256" },
          { name: "secondsPerBlock", type: "uint256" },
          { name: "referenceTxnHash", type: "string" },
          { name: "startApy", type: "uint256" },
          { name: "finalApy", type: "uint256" },
          { name: "resolved", type: "bool" },
          { name: "voided", type: "bool" },
          { name: "winningOption", type: "uint8" },
          { name: "rewardPerToken", type: "uint256" },
          { name: "durationEnum", type: "uint8" },
          { name: "thresholds", type: "int256[5]" }
        ],
        name: "opps",
        type: "tuple[]"
      },
      { name: "stakes", type: "uint256[6][]" },
      { name: "bettors", type: "uint256[6][]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "count", type: "uint256" }],
    name: "getRecentOpportunitiesWithPools",
    outputs: [
      {
        components: [
          { name: "name", type: "string" },
          { name: "startBlock", type: "uint256" },
          { name: "endBlock", type: "uint256" },
          { name: "secondsPerBlock", type: "uint256" },
          { name: "referenceTxnHash", type: "string" },
          { name: "startApy", type: "uint256" },
          { name: "finalApy", type: "uint256" },
          { name: "resolved", type: "bool" },
          { name: "voided", type: "bool" },
          { name: "winningOption", type: "uint8" },
          { name: "rewardPerToken", type: "uint256" },
          { name: "durationEnum", type: "uint8" },
          { name: "thresholds", type: "int256[5]" }
        ],
        name: "opps",
        type: "tuple[]"
      },
      { name: "stakes", type: "uint256[6][]" },
      { name: "bettors", type: "uint256[6][]" },
      { name: "ids", type: "uint256[]" }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "feeBps",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "usdc",
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "LISTER_ROLE",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "ORACLE_ROLE",
    outputs: [{ name: "", type: "bytes32" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "hasRole",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "role", type: "bytes32" },
      { name: "account", type: "address" }
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
];

// ERC20 ABI (for USDC)
export const ERC20_ABI = [
  {
    inputs: [
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" }
    ],
    name: "allowance",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", type: "uint8" }],
    stateMutability: "view",
    type: "function"
  },
];

// ERC1155 ABI (for Position Tokens)
export const ERC1155_ABI = [
  {
    inputs: [
      { name: "account", type: "address" },
      { name: "id", type: "uint256" }
    ],
    name: "balanceOf",
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "accounts", type: "address[]" },
      { name: "ids", type: "uint256[]" }
    ],
    name: "balanceOfBatch",
    outputs: [{ name: "", type: "uint256[]" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      { name: "from", type: "address" },
      { name: "to", type: "address" },
      { name: "id", type: "uint256" },
      { name: "amount", type: "uint256" },
      { name: "data", type: "bytes" }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "from", type: "address" },
      { name: "to", type: "address" },
      { name: "ids", type: "uint256[]" },
      { name: "amounts", type: "uint256[]" },
      { name: "data", type: "bytes" }
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "operator", type: "address" },
      { name: "approved", type: "bool" }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { name: "account", type: "address" },
      { name: "operator", type: "address" }
    ],
    name: "isApprovedForAll",
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
    type: "function"
  }
];

// Constants
export const USDC_DECIMALS = 6;

// Betting option labels
export const OPTIONS = [
  { index: 0, label: "≤ -20%", shortLabel: "≤-20%", color: "#dc2626" },
  { index: 1, label: "-20% to -10%", shortLabel: "-20%~-10%", color: "#ef4444" },
  { index: 2, label: "-10% to -5%", shortLabel: "-10%~-5%", color: "#f87171" },
  { index: 3, label: "-5% to +5%", shortLabel: "±5%", color: "#fbbf24" },
  { index: 4, label: "+5% to +20%", shortLabel: "+5%~+20%", color: "#4ade80" },
  { index: 5, label: "≥ +20%", shortLabel: "≥+20%", color: "#22c55e" }
];

// Duration labels
export const DURATIONS = {
  0: { label: "1 Day", shortLabel: "1d" },
  1: { label: "1 Week", shortLabel: "1w" },
  2: { label: "1 Month", shortLabel: "1m" }
};

// Web3Modal project ID
export const WEB3MODAL_PROJECT_ID = 'e20b431f30b58f031037e1ed4efd90c3';
